import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, makeStyles } from '@material-ui/core';
import ActionButton from '../../actionButton';
import OneOnOneTimeIndicator from '../../oneOnOneTimeIndicator';
import { ReactComponent as CalendarIcon } from '../../../../assets/icons/event_note.svg';
import { formatDate } from '../../../../utility/dateUtils';
import { CARD_DATE_FORMAT } from '../../../../constants/dashboard';
import { ACTION_BUTTON_TYPES } from '../../actionButton/config';

const useStyles = makeStyles(({ palette: { primary }, spacing }) => ({
  root: {
    boxSizing: 'border-box',
    borderRadius: 4,
    border: `1px solid ${primary.blue5}`,
    padding: spacing(4),
    transition: 'border .2s ease',
    '&:hover': {
      border: `1px solid ${primary.blue1}`,
    },
  },
  request: {
    position: 'relative',
  },
  iconButton: {
    position: 'absolute',
    top: -6,
    right: -5,
  },
  requestText: {
    marginTop: 'auto',
  },
  requestedOnWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 'auto',
  },
  calendarIcon: {
    marginTop: spacing(-1),
    marginRight: spacing(2),
  },
}));

const UserCard = ({
  className = undefined,
  translations,
  request,
  isExpired = false,
  onDeleteRequest,
  onChangeRequest,
}) => {
  const classes = useStyles();
  const { EDIT, DELETE_FILL } = ACTION_BUTTON_TYPES;
  const { created_at } = request;
  const date = formatDate(created_at, CARD_DATE_FORMAT);

  return (
    <div className={classNames(classes.root, className)}>
      <div className={classes.request}>
        <OneOnOneTimeIndicator labels={translations.statuses} />
        <ActionButton
          className={classes.iconButton}
          type={isExpired ? DELETE_FILL : EDIT}
          onClickHandler={isExpired ? onDeleteRequest : onChangeRequest}
        />
      </div>
      <Typography className={classes.requestText} variant="body2">
        {translations.userRequest}
      </Typography>
      <div className={classes.requestedOnWrapper}>
        <CalendarIcon className={classes.calendarIcon} />
        <Typography variant="body2">{`${date}`}</Typography>
      </div>
    </div>
  );
};

UserCard.propTypes = {
  className: PropTypes.string,
  translations: PropTypes.shape({}).isRequired,
  request: PropTypes.shape({}).isRequired,
  isExpired: PropTypes.bool,
  onChangeRequest: PropTypes.func.isRequired,
  onDeleteRequest: PropTypes.func.isRequired,
};

export default UserCard;
